<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 水司管理 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="水司名称">
              <a-input v-model="query.tenantName" placeholder="请输入水司名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value v-model="query.status" allow-clear>
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="myAddOrUpdateHandle()"
                v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <a-tag color="blue" slot="status" slot-scope="text">{{ text | statusFilter }}</a-tag>
      <span slot="action" slot-scope="text, record">
        <a @click="myAddOrUpdateHandle(record)" v-action:edit>编辑</a>
        <a-divider type="vertical" />
        <a @click="resetTenantPassword(record.id)" v-action:repassword>重置密码</a>
      </span>
    </a-table>
    <!--  新增修改操作  -->
    <a-modal title="操作" style="top: 20px;" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司简称" hasFeedback>
          <a-input placeholder="水司简称(如合汇科技,长度不超过8个)"
            v-decorator="['shortName', { rules: [{ required: true, message: '请输入水司简称' }, { max: 8, message: '长度不能超过8个字符' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司名称" hasFeedback>
          <a-input placeholder="水司名称"
            v-decorator="['tenantName', { rules: [{ required: true, message: '请输入水司名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司地址" hasFeedback>
          <a-input placeholder="水司地址" v-decorator="['address', { rules: [{ required: true, message: '请输入水司地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司状态">
          <a-select placeholder="请选择"
            v-decorator="['status', { rules: [{ required: true, message: '请选择水司状态' }], initialValue: 1 }]">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录账号" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="登录账号"
            v-decorator="['chargeUsername', { rules: [{ required: true, message: '请输入登录账号' }, { validator: checkData, trigger: 'blur' }] }]" />
        </a-form-item>
        <a-form-item v-if="!this.isUpdate" :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录密码" hasFeedback>
          <a-input-password placeholder="登录密码"
            v-decorator="['password', { rules: [{ required: true, message: '请输入登录密码' }, { validator: validatePassword, trigger: 'blur' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人姓名" hasFeedback>
          <a-input placeholder="负责人姓名"
            v-decorator="['chargeRealName', { rules: [{ required: true, message: '请输入负责人姓名' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="短信发送次数" hasFeedback>
          <a-input placeholder="短信发送次数"
            v-decorator="['messageNum', { rules: [{ required: true, message: '请输入短信发送次数' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="短信签名值" hasFeedback>
          <a-input placeholder="短信签名值需要在短信平台审核通过之后才能使用"
            v-decorator="['sign', { rules: [{ message: '短信签名值需要在短信平台审核通过之后才能使用' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="请选择经纬度">
          <!-- <a-input
            v-show='false'
            placeholder="请选择经纬度"
            v-decorator="['point']"
          /> -->
          <small-map-2 @mapHandle="mapHandle" :lon="pointX" :lat="pointY" v-if="addOrUpdateVisible"></small-map-2>
        </a-form-item>
        <a-form-item v-if="!this.isUpdate" :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人手机" hasFeedback>
          <a-input placeholder="负责人手机"
            v-decorator="['chargePhone', { rules: [{ pattern: '^1[0-9]{10}$', message: '请输入负责人手机' }] }]" />
        </a-form-item>
        <a-form-item v-if="!this.isUpdate" :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人邮箱" hasFeedback>
          <a-input
            v-decorator="['chargeEmail', { rules: [{ pattern: '^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$', message: '请输入负责人邮箱' }] }]"
            placeholder="负责人邮箱" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--  重置密码操作  -->
    <a-modal title="重置密码" style="top: 20px;" :width="800" v-model="resetPasswordVisible" v-action:repassword
      @ok="handleResetPassword" @cancel="handleRestPasswordCancel">
      <a-form class="tenant-form" :form="resetPasswordForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司简称" hasFeedback>
          <a-input hidden v-decorator="['tenantId']" />
          <a-input disabled placeholder="水司简称(如合汇科技,长度不超过8个)"
            v-decorator="['shortName', { rules: [{ required: true, message: '请输入水司简称' }, { max: 8, message: '长度不能超过8个字符' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司名称" hasFeedback>
          <a-input disabled placeholder="水司名称"
            v-decorator="['tenantName', { rules: [{ required: true, message: '请输入水司名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录账号" hasFeedback>
          <a-input disabled placeholder="登录账号"
            v-decorator="['chargeUsername', { rules: [{ required: true, message: '请输入登录账号' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录密码" hasFeedback>
          <a-input-password placeholder="登录密码"
            v-decorator="['password', { rules: [{ required: true, message: '请输入登录密码' }, { validator: validatePassword, trigger: 'blur' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import smallMap2 from './smallMap2.vue'

const STATUS = {
  1: '正常',
  2: '禁用'
}

const columns = [
  {
    title: '水司ID',
    dataIndex: 'tenantId'
  },

  {
    title: '水司简称',
    dataIndex: 'shortName'
  },
  {
    title: '水司名称',
    dataIndex: 'tenantName'
  },
  {
    title: '地址',
    dataIndex: 'address'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '登录账号',
    dataIndex: 'chargeUsername'
  },
  {
    title: '负责人',
    dataIndex: 'chargeRealName'
  },
  {
    title: '经纬度',
    dataIndex: 'point'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: { smallMap2 },
  mixins: [mixinViewModule],
  name: 'TenantList',
  data () {
    return {
      point: [0, 0],
      queryUrl: 'manager/tenants/page',
      addOrUpdateUrl: 'manager/tenants',
      queryOneUrl: 'manager/tenants',
      deleteUrl: 'manager/tenants',
      query: {
        tenantName: '',
        status: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      resetPasswordVisible: false,
      resetPasswordForm: this.$form.createForm(this, { name: 'restPassword' }),
      pointX: '',
      pointY: ''
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () { },
  methods: {
    myAddOrUpdateHandle (record) {
      if (record) {
        // 编辑
        console.log()
        this.pointX = record.pointX
        this.pointY = record.pointY
        console.log(this.pointX, '位置！')
        this.addOrUpdateHandle(record.id)
      } else {
        // 新增
        this.pointX = ''
        this.pointY = ''
        this.addOrUpdateHandle()
      }
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, { id: this.currentId, ...values, point: this.point }
          )
            .then((res) => {
              if (res.code === 0) {
                //新增租户的时候
                if (res.data.tenantId && !this.currentId) {
                  //新增指定租户导航信息
                  this.$http.get('/manager/users/insert/tenant/info/' + res.data.tenantId).then((res) => { })
                }
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {
            })
        }
      })
    },
    mapHandle (val) {
      this.point = val
    },
    validPassword (value) {
      console.log('===validPassword===', value)
      const num = /^.*[0-9]+.*/
      const low = /^.*[a-z]+.*/
      const up = /^.*[A-Z]+.*/
      const spe = /^.*[^a-zA-Z0-9]+.*/
      const passLength = value.length > 5 && value.length < 21
      return num.test(value) && low.test(value) && up.test(value) && spe.test(value) && passLength
    },
    validatePassword (rule, value, callback) {
      if (this.validPassword(value)) callback()
      else callback(new Error('密码6-20位，必须包含大写字母，小写字母，数字及特殊字符'))
    },
    // 正则不能输入中文
    checkData (rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('登录账号只能输入英文或数字、特殊符号!'))
        } else {
          callback()
        }
      }
      callback()
    },
    resetTenantPassword (id) {
      this.resetPasswordVisible = true
      this.$http
        .get(`${this.queryOneUrl}/${id}`)
        .then(({ data }) => {
          this.resetPasswordForm.setFieldsValue(data)
        })
        .catch(() => { })
    },
    handleResetPassword (e) {
      e.preventDefault()
      this.resetPasswordForm.validateFields((err, values) => {
        console.log(values)
        if (!err) {
          this.$http
            .put('/manager/tenants/reset-password', { tenantId: values.tenantId, password: values.password })
            .then(res => {
              if (res.code === 0) {
                this.resetPasswordVisible = false
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    handleRestPasswordCancel () {
      this.resetPasswordVisible = false
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
